var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.classes }, [
    _c(
      "div",
      { staticClass: "jon-info--message" },
      [
        _c("div", [_c("Jon", { attrs: { white: "" } })], 1),
        _vm._v(" "),
        _vm._t("message")
      ],
      2
    ),
    _vm._v(" "),
    _vm.footerImage
      ? _c("div", { staticClass: "jon-info--footer-image" }, [
          _c("img", { attrs: { src: _vm.footerImage, alt: "Abschluss-Bild" } })
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }